import { createAsyncThunk } from '@reduxjs/toolkit';

import { modelosComunicacaoService } from './services';
import type {
  CreateModeloComunicacaoDto,
  ModeloComunicacao,
  ModeloDocumentoOption,
  UpdateModeloComunicacaoDto,
} from '../types/modeloComunicacaoTypes';

const toErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof Error ? error.message : fallback;

export const listarModelosComunicacao = createAsyncThunk<
  ModeloComunicacao[],
  void,
  { rejectValue: string }
>('modelosComunicacao/listar', async (_, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.listar();
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível carregar os modelos.'));
  }
});

export const sincronizarMetaComunicacao = createAsyncThunk<
  { atualizados: number },
  void,
  { rejectValue: string }
>('modelosComunicacao/sincronizarMeta', async (_, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.sincronizarMeta();
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível sincronizar com a Meta.'));
  }
});

export const listarModelosDocumentoAnexo = createAsyncThunk<
  ModeloDocumentoOption[],
  void,
  { rejectValue: string }
>('modelosComunicacao/listarModelosDocumento', async (_, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.listarModelosDocumento();
  } catch (error) {
    return rejectWithValue(
      toErrorMessage(error, 'Não foi possível carregar os modelos de documento.'),
    );
  }
});

export const buscarModeloComunicacao = createAsyncThunk<
  ModeloComunicacao,
  string,
  { rejectValue: string }
>('modelosComunicacao/buscar', async (id, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.buscar(id);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível carregar o modelo.'));
  }
});

export const criarModeloComunicacao = createAsyncThunk<
  ModeloComunicacao,
  CreateModeloComunicacaoDto,
  { rejectValue: string }
>('modelosComunicacao/criar', async (data, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.criar(data);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível criar o modelo.'));
  }
});

export const atualizarModeloComunicacao = createAsyncThunk<
  ModeloComunicacao,
  { id: string; data: UpdateModeloComunicacaoDto },
  { rejectValue: string }
>('modelosComunicacao/atualizar', async ({ id, data }, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.atualizar(id, data);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível salvar o modelo.'));
  }
});

export const alternarStatusModeloComunicacao = createAsyncThunk<
  ModeloComunicacao,
  string,
  { rejectValue: string }
>('modelosComunicacao/alternarStatus', async (id, { rejectWithValue }) => {
  try {
    return await modelosComunicacaoService.alternarStatus(id);
  } catch (error) {
    return rejectWithValue(toErrorMessage(error, 'Não foi possível atualizar o status.'));
  }
});
